import { NoParamEndpointConstructor, SingleParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/promo-periods'

interface Endpoints {
  getAll: NoParamEndpointConstructor
  create: NoParamEndpointConstructor
  remove: SingleParamEndpointConstructor
  update: SingleParamEndpointConstructor
}

export const promoPeriodsEndpoints: Endpoints = {
  getAll: () => baseUrl,
  create: () => baseUrl,
  remove: (id) => `${baseUrl}/${id}`,
  update: (id) => `${baseUrl}/${id}`,
}
